import React from 'react';
import Imgix from 'react-imgix';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { BodyThree } from '../../../../../styles/theme/default/typography';
import FilterColor from './FilterColor';
import FilterMaterial from './FilterMaterial';
import FilterPattern from './FilterPattern';
import ShowResultsButton from './ShowResultsButton';

const Wrapper = styled.div`
  overflow: auto;
  padding: 0 15px 15px 15px;
  .close-btn-container {
    margin-top: 15px;
    margin-bottom: 25px;
    button {
      padding-left: 0;
      background: white;
      border: none;
      &:outline {
        border: none;
      }
    }
    img {
      width: 20px;
      height: auto;
    }
  }
  .filters-clear-all-container {
    display: flex;
    justify-content: space-between;
  }
`;

function Filters({
  materials,
  materialIds,
  setMaterialIds,
  colors,
  colorIds,
  setColorIds,
  patterns,
  patternIds,
  setPatternIds,
  clearFilters,
  showClearFiltersButton,
  toggle,
  totalFabricResults
}) {
  const match = useRouteMatch();

  const isOutdoor = ['outdoor', 'lampshades'].includes(
    match.params.categorySlug.toLowerCase()
  );

  return (
    <Wrapper>
      <div className="close-btn-container">
        <button onClick={toggle}>
          <Imgix
            className="close-icon"
            imgixParams={{ auto: 'compress,format' }}
            sizes="50px"
            src={`https://theinside.imgix.net/icons/close-x.svg`}
            htmlAttributes={{
              alt: 'close-icon'
            }}
          />
        </button>
      </div>

      <div className="filters-clear-all-container">
        <BodyThree bold={true}>Filters</BodyThree>
        {showClearFiltersButton ? (
          <BodyThree
            className="clear-all"
            onClick={clearFilters}
            color="#A83569"
          >
            Clear All
          </BodyThree>
        ) : (
          ''
        )}
      </div>

      <FilterColor
        colors={colors}
        setColorIds={setColorIds}
        colorIds={colorIds}
      />

      <FilterPattern
        patterns={patterns}
        patternIds={patternIds}
        setPatternIds={setPatternIds}
      />
      {!isOutdoor && (
        <FilterMaterial
          materials={materials}
          materialIds={materialIds}
          setMaterialIds={setMaterialIds}
        />
      )}

      <ShowResultsButton
        toggle={toggle}
        totalFabricResults={totalFabricResults}
      />
    </Wrapper>
  );
}

export default Filters;
